import { useEffect } from "react";

/**
 * When `active` (typically an error / failed-load flag), re-run `retry` as soon as
 * the browser reports it is back online. Pairs with a visible Retry button: the
 * button covers the case where the `online` event already fired, or never will
 * (some mobile browsers are flaky); this covers the case where the user just
 * waits.
 */
export function useOnlineRetry(retry: () => void, active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const onOnline = () => retry();
    window.addEventListener("online", onOnline);
    return () => window.removeEventListener("online", onOnline);
  }, [retry, active]);
}
